import { z } from 'zod';

/** Event catalog (PRD §13, GDD §12). Names are stable; props are validated loosely. */
export const ANALYTICS_EVENTS = [
  'session_start',
  'session_end',
  'tutorial_step',
  'level_start',
  'level_end',
  'booster_used',
  'rescue_offered',
  'rescue_taken',
  'shop_upgrade',
  'grand_opening',
  'offline_collect',
  'daily_gift',
  'streak',
  'share',
  'link_created',
  'link_opened',
  'help_complete',
  'ad_impression',
  'ad_failed',
  'purchase',
  'purchase_failed',
  'league_result',
  'feature_unlock',
  'assist_applied',
  'settings_change',
  'error',
  // growth: the first launch of an install (props: platform, source, medium, campaign) and the in-app review ask (props: trigger)
  'first_open',
  'review_prompt',
  // generic events for feature screens (props: screen/from, feature/action) so features need no new names
  'screen_view',
  'feature_action',
] as const;

export const AnalyticsEventSchema = z.object({
  name: z.enum(ANALYTICS_EVENTS),
  ts: z.number().int(),
  sessionId: z.string().max(64),
  props: z.record(z.string(), z.union([z.string().max(200), z.number(), z.boolean(), z.null()])).default({}),
});
export const AnalyticsBatchSchema = z.object({ events: z.array(AnalyticsEventSchema).max(200) });
export type AnalyticsEvent = z.infer<typeof AnalyticsEventSchema>;
